module.exports = __webpack_public_path__ + "static/media/empty-session.d665c07d.svg";